export const seoPages = {
  "creation-site-vitrine": {
    slug: "creation-site-vitrine",
    title: "Création de site vitrine professionnel",
    metaTitle: "Création de site vitrine professionnel en France | Fold Web Agency",
    metaDescription:
      "Création de sites vitrines modernes, rapides et responsives pour indépendants, TPE, PME, cabinets et prestataires de services partout en France.",
    eyebrow: "Site vitrine",
    heroTitle: "Création de site vitrine professionnel pour gagner en crédibilité",
    intro:
      "Fold Web Agency crée des sites vitrines professionnels pour présenter votre activité, rassurer vos prospects et transformer les visites en prises de contact. Chaque page est pensée pour être claire, rapide, lisible sur mobile et compréhensible par Google.",
    bullets: [
      "Arborescence claire pour présenter votre entreprise, vos services et vos preuves de confiance",
      "Design responsive adapté au mobile, à la tablette et à l'ordinateur",
      "Formulaire de contact, boutons d'action et parcours de conversion visibles",
      "Balises title, meta description, titres Hn, maillage interne et base SEO propre",
    ],
    sections: [
      {
        title: "Pour quels professionnels ?",
        body:
          "Un site vitrine est idéal pour une entreprise de service, un indépendant, un cabinet, un commerce, une association ou une PME qui veut présenter son activité de manière professionnelle. Nous construisons des pages utiles pour les visiteurs : services, réalisations, avis, présentation, contact et informations essentielles.",
      },
      {
        title: "Une structure orientée conversion",
        body:
          "Nous construisons chaque page autour d'un objectif simple : comprendre vite, rassurer, puis contacter. L'arborescence, les textes, les visuels et les boutons sont pensés pour accompagner un visiteur qui découvre votre entreprise et l'aider à passer à l'action sans friction.",
      },
      {
        title: "Une base SEO dès la mise en ligne",
        body:
          "La création du site intègre les fondamentaux du référencement naturel : URL propres, balises cohérentes, contenus structurés, sitemap, responsive design et temps de chargement maîtrisé. L'objectif est de donner à Google des signaux clairs dès le lancement.",
      },
    ],
    faq: [
      {
        question: "Combien de pages faut-il pour un site vitrine ?",
        answer:
          "La plupart des projets commencent avec 4 à 8 pages : accueil, services, réalisations, à propos, contact et pages légales.",
      },
      {
        question: "Le site sera-t-il visible sur mobile ?",
        answer:
          "Oui, le responsive est intégré dès le départ pour offrir une expérience confortable sur mobile, tablette et ordinateur.",
      },
      {
        question: "Le site vitrine peut-il évoluer plus tard ?",
        answer:
          "Oui. Le site peut commencer simplement puis évoluer avec de nouvelles pages, des contenus SEO, un espace client, des formulaires avancés ou des intégrations selon vos besoins.",
      },
    ],
  },
  "creation-site-wordpress": {
    slug: "creation-site-wordpress",
    title: "Création de site WordPress",
    metaTitle: "Création de site WordPress professionnel | Fold Web Agency",
    metaDescription:
      "Création de sites WordPress professionnels, performants, sécurisés et faciles à administrer pour entreprises, indépendants et PME en France.",
    eyebrow: "WordPress",
    heroTitle: "Création de site WordPress propre, évolutif et simple à gérer",
    intro:
      "Nous créons des sites WordPress adaptés aux besoins des professionnels : présentation de services, acquisition de contacts, gestion simple des contenus et base technique durable. L'objectif est d'avoir un site administrable sans sacrifier la performance ni la clarté.",
    bullets: [
      "Installation et configuration WordPress",
      "Thème adapté à votre identité visuelle et à vos objectifs commerciaux",
      "Pages administrables, contenus structurés et blocs faciles à modifier",
      "Optimisation performance, sécurité, sauvegardes et SEO de base",
    ],
    sections: [
      {
        title: "WordPress sans lourdeur inutile",
        body:
          "WordPress est puissant lorsqu'il est bien cadré. Nous évitons les empilements de plugins inutiles et nous gardons une structure maintenable, pour un site plus stable et plus facile à faire évoluer.",
      },
      {
        title: "Autonomie après livraison",
        body:
          "L'objectif est que vous puissiez modifier les contenus essentiels sans dépendance permanente. Nous pouvons aussi assurer la maintenance si vous préférez nous confier la partie technique.",
      },
      {
        title: "Un WordPress pensé pour durer",
        body:
          "Nous préparons le site avec une logique de croissance : pages services, blog, formulaires, suivi statistique, redirections et optimisations SEO peuvent être ajoutés progressivement sans repartir de zéro.",
      },
    ],
    faq: [
      {
        question: "Puis-je modifier mon site WordPress moi-même ?",
        answer:
          "Oui. Les contenus principaux peuvent être rendus administrables pour que vous puissiez mettre à jour textes, images et pages.",
      },
      {
        question: "WordPress est-il adapté au SEO ?",
        answer:
          "Oui, à condition d'avoir une structure propre, des pages rapides, des titres cohérents et des contenus utiles.",
      },
      {
        question: "Pouvez-vous optimiser un WordPress déjà en ligne ?",
        answer:
          "Oui. Nous pouvons auditer un site WordPress existant, corriger les points bloquants et améliorer la structure, les performances, la sécurité et les contenus.",
      },
    ],
  },
  "maintenance-wordpress": {
    slug: "maintenance-wordpress",
    title: "Maintenance WordPress",
    metaTitle: "Maintenance WordPress et sécurité | Fold Web Agency",
    metaDescription:
      "Maintenance WordPress pour garder votre site à jour, sécurisé, sauvegardé, fonctionnel et performant dans la durée.",
    eyebrow: "Maintenance",
    heroTitle: "Maintenance WordPress pour garder un site fiable, rapide et sécurisé",
    intro:
      "La maintenance WordPress permet de limiter les bugs, les failles de sécurité, les ralentissements et les interruptions. Nous assurons le suivi technique pour que votre site reste stable et disponible pour vos visiteurs.",
    bullets: [
      "Mises à jour WordPress, thèmes et extensions",
      "Sauvegardes, contrôles après mise à jour et vérification du bon fonctionnement",
      "Surveillance des formulaires et éléments critiques",
      "Interventions correctives, conseils techniques et suivi des alertes",
    ],
    sections: [
      {
        title: "Pourquoi maintenir un site ?",
        body:
          "Un site WordPress évolue avec son environnement : versions PHP, plugins, navigateurs, sécurité. Sans suivi, de petites alertes peuvent devenir des blocages visibles pour vos clients.",
      },
      {
        title: "Un suivi adapté à votre activité",
        body:
          "Nous pouvons intervenir ponctuellement ou mettre en place un suivi régulier. L'objectif est de protéger le site sans complexifier votre quotidien.",
      },
      {
        title: "Moins de risques pour votre visibilité",
        body:
          "Un site indisponible, piraté ou lent peut nuire à l'expérience utilisateur et au référencement. La maintenance aide à conserver une base saine pour vos prospects, vos formulaires et votre visibilité Google.",
      },
    ],
    faq: [
      {
        question: "La maintenance est-elle obligatoire ?",
        answer:
          "Elle n'est pas obligatoire, mais elle est fortement recommandée pour éviter les failles, les incompatibilités et les pertes de données.",
      },
      {
        question: "Pouvez-vous reprendre un site existant ?",
        answer:
          "Oui, après un audit rapide de l'installation, des extensions et de l'hébergement.",
      },
      {
        question: "Que se passe-t-il en cas de bug ?",
        answer:
          "Nous analysons l'origine du problème, sécurisons les éléments critiques et proposons une correction adaptée selon l'urgence et le niveau de maintenance prévu.",
      },
    ],
  },
  "referencement-seo": {
    slug: "referencement-seo",
    title: "Référencement SEO",
    metaTitle: "Référencement SEO pour site professionnel | Fold Web Agency",
    metaDescription:
      "Optimisation SEO pour améliorer la compréhension de votre site par Google, renforcer votre visibilité et attirer un trafic qualifié en France.",
    eyebrow: "SEO",
    heroTitle: "Référencement SEO pour être mieux compris par Google",
    intro:
      "Nous travaillons le SEO comme un levier de visibilité durable : technique propre, contenus utiles, structure lisible et signaux de confiance. L'objectif est d'aider vos pages à répondre clairement aux recherches de vos prospects.",
    bullets: [
      "Audit technique et corrections prioritaires",
      "Optimisation des titres, metas et contenus",
      "Structure de pages par intention de recherche",
      "Maillage interne et recommandations de notoriété",
    ],
    sections: [
      {
        title: "Un SEO centré sur l'intention",
        body:
          "Une page performe mieux quand elle répond à une question précise. Nous construisons les contenus autour des recherches réelles de vos prospects, sans bourrage de mots-clés.",
      },
      {
        title: "Technique et contenu ensemble",
        body:
          "Le SEO ne se résume pas aux balises. Il faut aussi des pages rapides, accessibles, bien reliées entre elles et suffisamment utiles pour mériter des liens et des contacts.",
      },
      {
        title: "Une progression nationale, sans ciblage local forcé",
        body:
          "Nous pouvons travailler une visibilité sur toute la France avec des pages de services claires, des contenus de fond, des cas clients et un maillage interne cohérent. L'objectif n'est pas de multiplier des pages géographiques faibles, mais de construire une autorité utile.",
      },
    ],
    faq: [
      {
        question: "Combien de temps faut-il pour voir des résultats SEO ?",
        answer:
          "Les premiers signaux peuvent apparaître en quelques semaines, mais une progression durable se mesure plutôt sur plusieurs mois.",
      },
      {
        question: "Le SEO remplace-t-il la publicité ?",
        answer:
          "Non. Le SEO construit une visibilité durable, tandis que la publicité peut générer du trafic plus rapidement. Les deux peuvent se compléter.",
      },
      {
        question: "Faut-il créer beaucoup de pages pour progresser ?",
        answer:
          "Pas forcément. Il vaut mieux créer moins de pages mais plus utiles, avec une intention claire, un contenu complet, des liens internes et des preuves de confiance.",
      },
    ],
  },
};

export const seoPageList = Object.values(seoPages);
